import React, { useState } from "react";
import Header from "../Header/HeaderWithNav";
import { Link } from "react-router-dom";
import Asidebar from "../Header/Asidebar";
import { v4 as uuidv4 } from "uuid"; // For unique IDs
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
const ItemTypes = {
  BUTTON: "button",
};

// DraggableButton Component
const DraggableButton = ({ row }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: ItemTypes.BUTTON,
    item: { id: row.id },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }));

  return (
    <button
      ref={drag}
      className="btn btn-success mx-2 mt-2"
      style={{
        opacity: isDragging ? 0 : 1,
        cursor: "pointer",
      }}
    >
      Q{row.questionNumber}
    </button>
  );
};

// DropArea Component for X and Y axes
const DropArea = ({ children, onDrop }) => {
  const [, drop] = useDrop({
    accept: ItemTypes.BUTTON,
    drop: (item) => onDrop(item.id),
  });

  return (
    <div
      ref={drop}
      style={{
        padding: "10px",
        minHeight: "50px",
        border: "no",
        width: "50%",
        textAlign: "center"
      }}
    >
      {children}
    </div>
  );
};

const AddQuota = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState();
  const [openDevice, setOpenDevice] = useState(false);
  const [openAge, setOpenAge] = useState(false);
  const [openGender, setOpenGender] = useState(false);
  const [rows, setRows] = useState([]);
  const [ansRow, setansRow] = useState([]);
  const [checkedOrder, setCheckedOrder] = useState([]); // Tracks order of Device, Age, Gender
  const [xAxisButtons, setXAxisButtons] = useState([]);
  const [yAxisButtons, setYAxisButtons] = useState([]);

  const handleQuestionAddRow = () => {
    if (checkedOrder.length === 0) {
      alert("Please select at least one option before adding a row.");
      return; // Prevent adding empty rows
    }

    let currentMaxQuestionNumber = rows.reduce(
      (max, row) => Math.max(max, row.questionNumber || 0),
      0
    );

    const newRows = checkedOrder
      .filter((option) => {
        const matchingTitle = titles.find(
          (title) => title.toLowerCase() === option.toLowerCase()
        );
        return matchingTitle && !rows.some((row) => row.value === matchingTitle);
      })
      .map((option) => {
        currentMaxQuestionNumber += 1;
        const matchingTitle = titles.find(
          (title) => title.toLowerCase() === option.toLowerCase()
        );
        return {
          id: `${matchingTitle}-${uuidv4()}`, // Unique ID
          value: matchingTitle,
          questionNumber: currentMaxQuestionNumber,
        };
      });

    // Add new rows to the main rows array
    setRows((prevRows) => [...prevRows, ...newRows]);

    // Split new rows into odd (X-axis) and even (Y-axis)
    const oddRows = newRows.filter((row) => row.questionNumber % 2 !== 0); // Odd rows (Q1, Q3, ...)
    const evenRows = newRows.filter((row) => row.questionNumber % 2 === 0); // Even rows (Q2, Q4, ...)

    // Add odd rows to X-axis buttons and even rows to Y-axis buttons
    setXAxisButtons((prev) => [...prev, ...oddRows]);
    setYAxisButtons((prev) => [...prev, ...evenRows]);

    // Clear checkedOrder after adding questions
    setCheckedOrder([]);
  };

  // Function to handle drag-and-drop between X-axis and Y-axis
  const handleDrop = (id) => {
    const moveButton = (sourceButtons, setSourceButtons, targetButtons, setTargetButtons) => {
      const buttonToMove = sourceButtons.find((button) => button.id === id);
      if (buttonToMove) {
        setSourceButtons(sourceButtons.filter((button) => button.id !== id));
        setTargetButtons([...targetButtons, buttonToMove]);
      }
    };

    if (xAxisButtons.some((button) => button.id === id)) {
      moveButton(xAxisButtons, setXAxisButtons, yAxisButtons, setYAxisButtons);
    } else if (yAxisButtons.some((button) => button.id === id)) {
      moveButton(yAxisButtons, setYAxisButtons, xAxisButtons, setXAxisButtons);
    }
  }; const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };
  const [checked, setChecked] = useState({
    device: false,
    age: false,
    gender: false,
    device1: false,
    device2: false,
    device3: false,
  });
  // Array of available options
  const titles = ["Device", "Age", "Gender"];
  // const handleQuestionAddRow = () => {
  //   const selectedOptions = Object.keys(checked).filter((key) => checked[key]);

  //   if (selectedOptions.length === 0) {
  //     alert("Please select at least one option before adding a row.");
  //     return; // Prevent adding empty rows
  //   }

  //   // Determine where to insert the new questions
  //   const nextQuestionNumber = rows.reduce((max, row) => Math.max(max, row.questionNumber || 0), 0) + 1;

  //   setRows((prevRows) => [
  //     ...prevRows,
  //     ...selectedOptions
  //       .filter((option) => {
  //         const matchingTitle = titles.find(
  //           (title) => title.toLowerCase() === option.toLowerCase()
  //         );
  //         return matchingTitle && !prevRows.some((row) => row.value === matchingTitle);
  //       })
  //       .map((option) => {
  //         const matchingTitle = titles.find(
  //           (title) => title.toLowerCase() === option.toLowerCase()
  //         );

  //         // Assign unique IDs and maintain order
  //         return {
  //           id: `${matchingTitle}-${uuidv4()}`, // Descriptive unique ID
  //           value: matchingTitle,
  //           questionNumber: nextQuestionNumber // Assign question number in order
  //         };
  //       }),
  //   ]);
  // // };
  // const handleQuestionAddRow = () => {
  //     if (checkedOrder.length === 0) {
  //         alert("Please select at least one option before adding a row.");
  //         return; // Prevent adding empty rows
  //     }

  //     // Get the current max question number in the rows
  //     let currentMaxQuestionNumber = rows.reduce(
  //         (max, row) => Math.max(max, row.questionNumber || 0),
  //         0
  //     );

  //     // Filter out selectedOptions based on checkedOrder
  //     const newRows = checkedOrder
  //         .filter((option) => {
  //             const matchingTitle = titles.find(
  //                 (title) => title.toLowerCase() === option.toLowerCase()
  //             );
  //             return (
  //                 matchingTitle && !rows.some((row) => row.value === matchingTitle)
  //             ); // Filter out already added rows
  //         })
  //         .map((option) => {
  //             // Increment question number sequentially
  //             currentMaxQuestionNumber += 1;

  //             const matchingTitle = titles.find(
  //                 (title) => title.toLowerCase() === option.toLowerCase()
  //             );

  //             return {
  //                 id: `${matchingTitle}-${uuidv4()}`, // Unique ID
  //                 value: matchingTitle,
  //                 questionNumber: currentMaxQuestionNumber, // Assign sequential question number
  //             };
  //         });

  //     // Add the new rows to the existing rows
  //     setRows((prevRows) => [...prevRows, ...newRows]);

  //     // Clear checkedOrder after adding questions
  //     setCheckedOrder([]);
  // };

  const addRows = () => {
    const devices = {
      device1: "Tablet",
      device2: "Laptop",
      device3: "Mobile",
    };

    // Filter checked devices to get selected ones
    const selectedDevices = Object.keys(devices).filter(
      (deviceKey) => checked[deviceKey]
    );
    if (selectedDevices.length === 0) {
      alert("Please select at least one device before adding a row.");
      return; // Prevent adding empty rows
    }

    // Create an array of selected device names
    const selectedDeviceNames = selectedDevices.map((key) => devices[key]);

    // Check if this combination of devices already exists in ansRow
    const isDuplicate = ansRow.some((row) => {
      const rowDevices = row.value;
      // Check if the arrays are the same length and contain the same devices
      return (
        rowDevices.length === selectedDeviceNames.length &&
        rowDevices.every((device) => selectedDeviceNames.includes(device))
      );
    });

    if (isDuplicate) {
      alert("This combination of devices has already been added.");
      return; // Prevent adding duplicate rows
    }

    // Add the row with the selected device names if it's not a duplicate
    const newRow = {
      id: uuidv4(),
      value: selectedDeviceNames, // Store selected devices as an array
    };

    setansRow((prevRows) => [...prevRows, newRow]);
  };
  // Remove a row
  const removeRow = (id) => {
    // Remove the row from the rows state
    setRows((prevRows) => prevRows.filter((row) => row.id !== id));

    // Remove the button from either X-axis or Y-axis
    setXAxisButtons((prevButtons) => prevButtons.filter((button) => button.id !== id));
    setYAxisButtons((prevButtons) => prevButtons.filter((button) => button.id !== id));

    console.log("RowID----------------------", id);
  };
  const removeRow1 = (id) => {
    setansRow((prevRows) => prevRows.filter((answRow) => answRow.id !== id));
  };
  // Handle checkbox state changes
  // const handleCheckboxChange = (event) => {
  //   const { name, checked } = event.target;
  //   // Update the state for the specific checkbox
  //   setChecked(prevState => ({
  //     ...prevState,
  //     [name]: checked
  //   }));
  // };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    // Handle the main checkboxes for Device, Age, and Gender
    if (["device", "age", "gender"].includes(name)) {
      setChecked((prevState) => ({
        ...prevState,
        [name]: checked,
      }));

      // Update checkedOrder based on selection
      setCheckedOrder((prevOrder) => {
        if (checked) {
          // If checked, add to the order if not already present
          if (!prevOrder.includes(name)) {
            return [...prevOrder, name]; // Add to the end of the list
          }
        } else {
          // If unchecked, remove from the order
          return prevOrder.filter((item) => item !== name);
        }
        return prevOrder;
      });
    } else {
      // Handle sub-layer checkboxes (device1, device2, device3) without tracking their order
      setChecked((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    }
  };

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />
        <div className="container-fluid py-3">
          <div className="column p-1">
            <div className="row mheight">
              <div className="col-lg-4">
                <div className="card p-2 border-light-subtle h-100">
                  <div
                    className="common_form p-2 d-flex justify-content-between align-items-center border-bottom pb-2"
                    id="quotaStatement"
                  >
                    <span className="form-check-label ps-2">
                      Quota Statement
                    </span>
                    <div className="common_form p-1 d-flex justify-content-between align-items-center">
                      <button
                        className="btn btn-success custom-button"
                        onClick={handleQuestionAddRow}
                      >
                        <label className="mb-1" style={{ fontSize: "12px" }}>
                          + Que
                        </label>
                      </button>
                      <button
                        className="btn btn-success mx-1 custom-button"
                        onClick={addRows}
                      >
                        <label className="mb-1" style={{ fontSize: "12px" }}>
                          + Ans
                        </label>
                      </button>
                    </div>
                  </div>
                  <div
                    id="scrollspyContainer"
                    data-bs-spy="scroll"
                    data-bs-target="#quotaStatement"
                    data-bs-offset="0"
                    tabIndex="0"
                    style={{
                      height: "500px",
                      overflowY: "scroll",
                      position: "relative",
                    }}
                  >
                    <div className="px-2">
                      <div className="d-flex align-items-center border-bottom px-4 pb-2 mt-3">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            id="device"
                            name="device"
                            checked={checked.device}
                            onChange={handleCheckboxChange}
                          />
                        </div>
                        <div className="col-lg-7 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for="device"
                            name="device"
                          >
                            Device
                          </label>
                        </div>
                        <div
                          className="col-lg-2 d-flex justify-content-end"
                          onClick={() => setOpenDevice(!openDevice)}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`bi bi-chevron-${openDevice ? "up" : "down"
                              } fs-17`}
                          ></i>
                        </div>
                      </div>
                      {openDevice && (
                        <div className="px-5 py-2 border-bottom">
                          <div className="form-check border-bottom mt-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="device1"
                              name="device1"
                              checked={checked.device1}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label ps-4"
                              htmlFor="device1"
                            >
                              Tablet
                            </label>
                          </div>
                          <div className="form-check border-bottom mt-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="device2"
                              id="device2"
                              checked={checked.device2}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label ps-4"
                              htmlFor="device2"
                            >
                              Laptop
                            </label>
                          </div>
                          <div className="form-check mt-2">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id="device3"
                              name="device3"
                              checked={checked.device3}
                              onChange={handleCheckboxChange}
                            />
                            <label
                              className="form-check-label ps-4"
                              htmlFor="device3"
                            >
                              Mobile
                            </label>
                          </div>
                        </div>
                      )}
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            id="age"
                            name="age"
                            checked={checked.age}
                            onChange={handleCheckboxChange}
                          />{" "}
                        </div>
                        <div className="col-lg-4 d-flex justify-content-start">
                          <label className="form-check-label ps-2" for=" Age">
                            Age
                          </label>
                        </div>
                        <div
                          className="col-lg-5 d-flex justify-content-end"
                          onClick={() => setOpenAge(!openAge)}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`bi bi-chevron-${openAge ? "up" : "down"
                              } fs-17`}
                          ></i>
                        </div>
                      </div>
                      {openAge && (
                        <div className="px-5 py-2">
                          {/* Add user answers here */}
                        </div>
                      )}
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            id="gender"
                            name="gender"
                            checked={checked.gender}
                            onChange={handleCheckboxChange}
                          />
                        </div>
                        <div className="col-lg-4 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for=" Gender"
                          >
                            Gender
                          </label>
                        </div>
                        <div
                          className="col-lg-5 d-flex justify-content-end"
                          onClick={() => setOpenGender(!openGender)}
                          style={{ cursor: "pointer" }}
                        >
                          <i
                            className={`bi bi-chevron-${openGender ? "up" : "down"
                              } fs-17`}
                          ></i>
                        </div>
                      </div>
                      {openGender && (
                        <div className="px-5 py-2">
                          {/* Add user answers here */}
                        </div>
                      )}
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            value=""
                            id="Employment status"
                          ></input>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for="Employment status"
                          >
                            Employment status
                          </label>
                        </div>
                        <div className="col-lg-3 d-flex justify-content-end">
                          <i className="bi bi-chevron-down fs-17"></i>
                        </div>
                      </div>
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            value=""
                            id=" Work Experience"
                          ></input>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for=" Work Experience"
                          >
                            Work Experience
                          </label>
                        </div>
                        <div className="col-lg-3 d-flex justify-content-end">
                          <i className="bi bi-chevron-down fs-17"></i>
                        </div>
                      </div>
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            value=""
                            id=" Company Size"
                          ></input>
                        </div>
                        <div className="col-lg-5 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for=" Company Size"
                          >
                            Company Size
                          </label>
                        </div>
                        <div className="col-lg-4 d-flex justify-content-end">
                          <i className="bi bi-chevron-down fs-17"></i>
                        </div>
                      </div>
                      <div className="d-flex border-bottom px-4 py-2">
                        <div className="form-check col-lg-3 d-flex justify-content-start">
                          <input
                            className="form-check-input fs-19"
                            type="checkbox"
                            value=""
                            id=" Company revenue"
                          ></input>
                        </div>
                        <div className="col-lg-6 d-flex justify-content-start">
                          <label
                            className="form-check-label ps-2"
                            for=" Company revenue"
                          >
                            Company revenue
                          </label>
                        </div>
                        <div className="col-lg-3 d-flex justify-content-end">
                          <i className="bi bi-chevron-down fs-17"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="card h-100 p-2 border-light-subtle">
                  <div className="column p-2">
                    <div className="row border-bottom px-4 pb-2 d-flex justify-content-between align-items-center">
                      <div className="col-lg-3 ps-4">
                        <input
                          type="text"
                          style={{
                            fontSize: "12px",
                            padding: "2px",
                          }}
                          className="form-control text-center"
                          placeholder="Quota Title"
                        />
                      </div>
                      <div className="col-lg-3 d-flex align-items-center button-group">
                        <div className="tooltip-wrapper">
                          <button className="btn btn-left px-2 py-0">
                            <label>Click</label>
                          </button>
                          <div className="tooltip">
                            Quota Type
                            <div className="tooltip-arrow"></div>
                          </div>
                        </div>
                        <div className="tooltip-wrapper">
                          <button className="btn btn-right px-1 py-1">
                            <label>Qualified</label>
                          </button>
                          <div className="tooltip">
                            Quota Type
                            <div className="tooltip-arrow"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    {rows.map((row) => (
                      <div className="px-2" key={row.id}>
                        <div className="d-flex border-bottom px-4 pb-2 align-items-center mt-2">
                          <div className="form-check col-lg-1 d-flex justify-content-start">
                            <input
                              className="form-check-input fs-19"
                              type="checkbox"
                              value=""
                            />
                          </div>
                          <div className="col-lg-3 d-flex align-items-center">
                            <label className="form-check-label">
                              Question Layer
                            </label>
                            <i className="bi bi-chevron-down fs-17 ms-2"></i>
                          </div>
                          <div className="col-lg-7">
                            <label className="form-check-label ms-2">
                              {row.value}
                            </label>
                          </div>
                          <div className="trash">
                            <button
                              className="trash1 me-2"
                              onClick={() => removeRow(row.id)}
                            >
                              {/* Trash Icon */}
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="red"
                                className="bi bi-trash3-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                              </svg>
                            </button>
                          </div>
                        </div>

                        {/* Render Sub Layer for Device */}
                        {row.value === "Device" &&
                          ansRow.length > 0 &&
                          ansRow.map((subRow) => (
                            <div>
                              <div className="pe-2" key={subRow.id}>
                                <div className="d-flex border-bottom px-4 bottom-2 align-items-center mt-2">
                                  <div className="form-check col-flexlg-1 d-flex justify-content-start">
                                    <input
                                      className="form-check-input fs-19 me-4"
                                      type="checkbox"
                                      value=""
                                    />
                                  </div>
                                  <div className="col-lg-3 d-flex align-items-center">
                                    <label className="form-check-label ms-2">
                                      Sub Layer
                                    </label>
                                    <i className="bi bi-chevron-down fs-17 ms-2"></i>
                                  </div>
                                  {subRow.value.length === 3 && (
                                    <>
                                      <div className="col-lg-2 d-flex gap-2 align-items-center">
                                        <label className="form-check-label ms-3">
                                          {subRow.value[0]}
                                        </label>
                                        <label className="blue-label ms-2 ">
                                          {" "}
                                          or
                                        </label>
                                      </div>
                                      <div className="col-lg-2 d-flex gap-2 align-items-center">
                                        <label className="form-check-label ms-2">
                                          {subRow.value[1]}
                                        </label>
                                        <label className="blue-label ms-2">
                                          {" "}
                                          or
                                        </label>
                                      </div>
                                      <div className="col-lg-2 d-flex gap-2 align-items-center">
                                        <label className="form-check-label ms-1">
                                          {subRow.value[2]}
                                        </label>
                                      </div>
                                    </>
                                  )}
                                  {subRow.value.length === 2 && (
                                    <>
                                      <div className="col-lg-2 d-flex gap-2 align-items-center">
                                        <label className="form-check-label ms-2">
                                          {subRow.value[0]}
                                        </label>
                                        <label className="blue-label ms-1">
                                          {" "}
                                          or
                                        </label>
                                      </div>
                                      <div className="col-lg-2 d-flex gap-2 align-items-center">
                                        <label className="form-check-label ms-2">
                                          {subRow.value[1]}
                                        </label>
                                      </div>
                                    </>
                                  )}
                                  {subRow.value.length === 1 && (
                                    <div className="col-lg-2 d-flex gap-2 align-items-center">
                                      <label className="form-check-label ms-2">
                                        {subRow.value[0]}
                                      </label>
                                    </div>
                                  )}
                                  <div className="trash">
                                    <button
                                      className="trash1 ms-4 d-flex align-items-center "
                                      onClick={() => removeRow1(subRow.id)}
                                    >
                                      {/* Trash Icon */}
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="16"
                                        height="16"
                                        fill="red"
                                        className="bi bi-trash3-fill"
                                        viewBox="0 0 16 16"
                                      >
                                        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5m-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5M4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06m6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528M8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5" />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))}
                  </div>
                  <div className="col-lg-2 d-flex align-items-center button-group position-absolute bottom-0 end-0 me-3 mb-2 justify-content-end">
                    <Link to="/view-quota">
                      <button className="btn btn-success px-4 fs-10">
                        Save
                      </button>
                    </Link>
                  </div>
                </div>
              </div>
              <DndProvider backend={HTML5Backend}>


                {/* X-axis Drop Area */}
                <div className="col-lg-2 card h-200 p-2 border-light-subtle">
                  <div className="d-flex h-100 p-2">
                    <DropArea onDrop={(id) => handleDrop(id, "xAxis")} width="50%">
                      <div >
                        <label>
                          <b>X-axis</b>
                        </label>
                      </div>
                      <div className="mb-2 mt-2">
                        {xAxisButtons.map((row) => (
                          <DraggableButton key={row.id} row={row} />
                        ))}
                      </div>
                    </DropArea>

                    <div
                      className="border-start"
                      style={{
                        width: "1px",
                        backgroundColor: "#ddd",
                      }}
                    ></div>

                    {/* Y-axis Drop Area */}
                    <DropArea onDrop={(id) => handleDrop(id, "yAxis")}>
                      <div >
                        <label>
                          <b>Y-axis</b>
                        </label>
                      </div>
                      <div className="mb-2 mt-2">
                        {yAxisButtons.map((row) => (
                          <DraggableButton key={row.id} row={row} />
                        ))}
                      </div>
                    </DropArea>
                  </div>
                </div>

              </DndProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddQuota;
